import React from 'react';
import Select from 'react-select';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import Modal from 'buyside/components/presentation/Modal/modal';

import styles from './flagItemModalStyles';

class FlagItemModal extends React.Component {
  constructor() {
    super();
    this.state = {
      modalOpen: false,
      body: '',
      error: '',
      loading: false,
      category: '',
      complete: false
    };
    this.closeModal = this.closeModal.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleBodyChange = this.handleBodyChange.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
  }

  closeModal() {
    this.setState({ modalOpen: false });
  }

  handleBodyChange(e) {
    this.setState({ body: e.currentTarget.value });
  }

  handleSelectChange(selectedOption) {
    this.setState({ category: selectedOption ? selectedOption.value : '' });
  }

  handleSubmit() {
    const { body, category } = this.state;
    const { flagItem, itemId, type } = this.props;
    if (!category) {
      this.setState({
        error: 'Please select a reason for flagging this content'
      });
    } else if (!body) {
      this.setState({ error: 'Please enter a description' });
    } else {
      this.setState({ error: '', loading: true });
      flagItem({ itemId, category, type, description: body }).then(
        () => {
          this.setState({ loading: false, body: '', complete: true });
        },
        () => {
          this.setState({
            loading: false,
            error:
              'There was an error flagging this item. Please try again or contact support@sumzero.com.'
          });
        }
      );
    }
  }

  renderOpenModalButton(buttonOptions) {
    return (
      <Button
        {...buttonOptions}
        onClick={() => this.setState({ modalOpen: true, complete: false })}
      />
    );
  }

  render() {
    const { loading, body, category, error, complete, modalOpen } = this.state;
    const { buttonOptions, type, name } = this.props;

    const selectOptions = [
      { value: 'return', label: 'Return is incorrect' },
      {
        value: 'content',
        label: 'Content is inaccurate/inappropriate'
      }
    ];

    return (
      <Modal
        isOpen={modalOpen}
        onClose={this.closeModal}
        renderOpenModalButton={() => this.renderOpenModalButton(buttonOptions)}
        title={complete ? `${name || type} Flagged` : `Flag ${name || type}`}
      >
        {(!complete && (
          <div>
            <div>
              <div className={styles.labelItem}>
                <label className={styles.bodyLabel}>Why are you flagging this content?</label>
                <div className={styles.fullWidth}>
                  <Select
                    menuShouldScrollIntoView={false}
                    value={selectOptions.filter(option => option.value === category)}
                    onChange={this.handleSelectChange}
                    options={selectOptions}
                  />
                </div>
              </div>
              <div className={styles.labelItem}>
                <label className={styles.bodyLabel}>Describe the problem in detail</label>
                <div className={styles.fullWidth}>
                  <textarea
                    placeholder="Enter your message here"
                    className={styles.bodyInput}
                    disabled={loading}
                    onChange={this.handleBodyChange}
                    value={body}
                  />
                </div>
              </div>
            </div>
            {error && <div className={styles.errorSection}>{error}</div>}
            <div className={styles.buttonArea}>
              <Button
                text="Send Request"
                type={BUTTON_TYPES.PRIMARY}
                onClick={this.handleSubmit}
                isLoading={loading}
              />
              <Button text="Cancel" onClick={this.closeModal} />
            </div>
          </div>
        )) || (
          <div>
            <div className={styles.successText}>This {name || type} was flagged successfully.</div>
            <Button text="OK" onClick={this.closeModal} type={BUTTON_TYPES.PRIMARY} />
          </div>
        )}
      </Modal>
    );
  }
}

export default FlagItemModal;
